/**
 * Survey Domain Configuration
 *
 * The CSAT public survey is served under two domains via a single deployment:
 *   1. crm.underadscapital.com  — full CRM (staff-facing)
 *   2. tradingfeedback.com      — public survey only (client-facing, no CRM branding)
 *
 * When a request arrives, we check window.location.hostname:
 *   - if it matches a survey-only hostname → App.js renders ONLY /s/:token routes
 *   - otherwise → the normal CRM shell is rendered
 *
 * To add or change domains, edit SURVEY_HOSTNAMES below OR set
 * REACT_APP_SURVEY_DOMAINS="tradingfeedback.com,www.tradingfeedback.com" in
 * frontend/.env — env values are appended to the built-in list.
 */

const BUILT_IN = [
  'tradingfeedback.com',
  'www.tradingfeedback.com',
];

const fromEnv = (process.env.REACT_APP_SURVEY_DOMAINS || '')
  .split(',')
  .map(s => s.trim().toLowerCase())
  .filter(Boolean);

export const SURVEY_HOSTNAMES = Array.from(new Set([...BUILT_IN, ...fromEnv]));

/** true when the currently loaded page is on the client-facing survey domain */
export function isSurveyHost() {
  if (typeof window === 'undefined') return false;
  const h = (window.location.hostname || '').toLowerCase();
  return SURVEY_HOSTNAMES.includes(h);
}

/** Primary survey domain — used when constructing public survey links from CRM. */
export const PRIMARY_SURVEY_HOST = SURVEY_HOSTNAMES[0];

/**
 * Build the client-facing public URL for a given survey token.
 * Uses tradingfeedback.com by default, or falls back to current origin
 * (useful for preview / local dev).
 */
export function buildPublicSurveyUrl(token) {
  if (typeof window === 'undefined') return `/s/${token}`;
  const proto = window.location.protocol || 'https:';
  // In production we prefer the public survey domain; in preview / local
  // dev the survey domain is not configured yet, so use the current origin.
  const isProduction = /emergent\.host|underadscapital\.com/i.test(window.location.host);
  const host = isProduction && PRIMARY_SURVEY_HOST ? PRIMARY_SURVEY_HOST : window.location.host;
  return `${proto}//${host}/s/${token}`;
}
